import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Header: React.FC = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header style={{
      backgroundColor: '#ffffff',
      borderBottom: '1px solid #e0e0e0',
      padding: '0 20px',
      height: '64px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src="/casante-logo.png"
          alt="Casante Checks logo"
          style={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          marginRight: '8px',
          }}
        />
        <Link
          to="/"
          style={{
            fontFamily: '"Montserrat", sans-serif',
            fontWeight: 700,
            color: '#212121',
            textDecoration: 'none',
            fontSize: '20px'
          }}
        >
          casanté
        </Link>
      </div>
      
      <div>
        {isAuthenticated ? (
          <button
            onClick={handleLogout}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: '#333',
              padding: '8px 16px',
              cursor: 'pointer',
              fontSize: '16px',
              borderRadius: '4px'
            }}
          >
            Logout
          </button>
        ) : (
          <>
            <Link
              to="/signup/payment"
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                color: '#333',
                padding: '8px 16px',
                cursor: 'pointer',
                fontSize: '16px',
                borderRadius: '4px',
                textDecoration: 'none',
                marginRight: '8px'
              }}
            >
              Sign Up
            </Link>
            <Link
              to="/login"
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                color: '#333',
                padding: '8px 16px',
                cursor: 'pointer',
                fontSize: '16px',
                borderRadius: '4px',
                textDecoration: 'none'
              }}
            >
              Login
            </Link>
          </>
        )}
      </div>
    </header>
  );
};

export default Header; 